<button [style.background]="color" type="button" (click)="open()">
      <i class="fa-solid fa-cart-shopping"></i>
      <span>Adicionar ao Carrinho</span> 
</button>      
